(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment New/Edit  
    module.controller('AgendaAppointmentDetailController',
        ['$state', '$scope', '$rootScope', '$uibModal', 'ExternalPatientBroadcast', 'ContactService', '$timeout', 'PatientConstant', 'AgendaBroadcast', 'AppointmentDetailService', 'RfGlobalLongDateFilterFilter', 'SharedAgendaService', 'AgendaTransitionService',
            'HelperService', 'DateService', 'AppointmentService', 'Appointment', 'ProtocolBroadcastService', 'ProtocolFilter', 'CallsService', 'CallPhoneStatus',
            'RecurrenceWeekOfMonth', 'AppointmentRecurrenceUpdateService', 'RecurrenceUpdateMethod', 'RecurrenceDuration', '$translate',
            'additionalinfotypes','SearchService', 'UserService', 'GroupPracticeService', 'PreviousState', 'ContactInfo', 'UserContactinfoType', 'Alert', AgendaAppointmentDetailControllerFn]);

    function AgendaAppointmentDetailControllerFn($state, $scope, $rootScope, $uibModal, ExternalPatientBroadcast, ContactService, $timeout, PatientConstant, AgendaBroadcast, AppointmentDetailService, RfGlobalLongDateFilterFilter,
        SharedAgendaService, AgendaTransitionService, HelperService, DateService, AppointmentService, Appointment, ProtocolBroadcastService, ProtocolFilter, CallsService, CallPhoneStatus,
        RecurrenceWeekOfMonth, AppointmentRecurrenceUpdateService, RecurrenceUpdateMethod, RecurrenceDuration, $translate, additionalinfotypes, SearchService, UserService, GroupPracticeService, PreviousState, ContactInfo, UserContactinfoType, Alert) {
        var vm = this;

        // current agenda
        vm.agenda = {};
        // current day
        vm.date = {};
        // current appointment
        vm.appointment = {};
        // appointment types 
        vm.types = {};
        // list of possible agenda-label items 
        vm.labels = [];
        // list of possible duration-intervals
        vm.durationIntervals = [];
        //name of doctor and email
        vm.email = null;
        // name of doctor and mobile
        vm.mobile = null;
        // list of possible additional infos 
        vm.additionalinfotypes = [];
        // options for week-of-month selection first, last,...)
        vm.weekOfMonthValues = [];
        vm.locations = [];
        // set dropdowntext of known-unknown
        vm.newOrUnknownText = '-';

        // Is The Appointment made For TODAY ?
        vm.dayItself = false;

        vm.defaultLocationName = null;
        vm.isDefaultLocationFromAppointmentType = false;
        
        vm.isAllowedToSeeSensitiveInfo = $rootScope.isAllowedToSeeSensitiveInfo;

        // looks for a patient and shows the user selection dropdown,
        // when opening the appointment
        vm.userQuery = '';

        // the appointmenttype is validated when opening the appointment form or when changing the appointment type 
        vm.notEnoughTimeForAppointmentType = false;

        vm.disableConfirmationOptions = false;

        vm.userBlocked = false;
        
        vm.initialFirstName = '';
        vm.initialLastName = '';
        
        vm.overwritingNationalNumber = false;

        // watcher
        var labelWatcher;
        var userWatcher;
        var addListener;
        var ciListener;
        
        vm.overwriteNationalNumber = () => {
          vm.overwritingNationalNumber = true;  
        };

        vm.showNnInfo = () => {
            HelperService.showInfoModal(
                'national_number_info_header',
                'national_number_info');
        };

        /* quick search patients */
        vm.search = function (searchValue, birthday) {
            return SearchService.searchPatients(AppointmentDetailService.data.agenda.owner.id, searchValue, birthday);
        };

        // set selected week of month value
        vm.selectWeekOfMonth = function (selection) {
            vm.appointment.recurrence.weekOfMonth = selection;
        };

        // set duration option automatically when associated input field is clicked
        vm.setDurationOption = function (value) {
            vm.appointment.recurrence.durationOption = value;

            // clear input fields of inactive options on selection change
            switch (value) {
                case RecurrenceDuration.NoEnd:
                    vm.appointment.recurrence.endDate = null;
                    vm.appointment.recurrence.recurrenceCounter = null;
                    break;

                case RecurrenceDuration.EndAfterXAppointments:
                    vm.appointment.recurrence.endDate = null;
                    break;

                case RecurrenceDuration.EndOnDate:
                    vm.appointment.recurrence.recurrenceCounter = null;
                    break;
            }
        };

        // set selected recurrence period (daily, weekly, ...)
        vm.setRecurrencePeriod = function (period) {
            vm.appointment.recurrence.period = period;
        };

        // abort
        vm.abort = function () {
            $state.go("Home.Agenda_Day");
        };


        // save appointment
        vm.confirmSave = function () {    
            // if videoconsult, please confirm
            if (vm.appointment.appointmentType.askConfirmationWhileSaving)
            {
                $uibModal.open({
                    backdrop: false,
                    keyboard: false,
                    animation: true,
                    templateUrl: '/app/agenda/templates/agenda-appointment-confirm-appointment-save.template.html',
                    controller: 'AgendaAppointmentConfirmAppointmentSavePopupController',
                    controllerAs: 'vm',
                    size: 'xs',
                    resolve: {
                        appointmentType: function () {
                            return vm.appointment.appointmentType;
                        }
                    },
                }).result.then(function (okToSaveAppointment)
                {
                    if (okToSaveAppointment)
                    {
                        confirmPatientAndSave();
                    }
                });
            }else{
                confirmPatientAndSave();
            }
            
            
        };
        
        function confirmPatientAndSave(){
            if (vm.moreThanOneEmail()) {
                Alert.error('single_email_allowed');
                return;
            }
            
            //check patient data
            if (!vm.appointment.patient.lastName) {
                return;
            }
            // check if user really wants to update the existing contact
            if (vm.appointment.patient.id > 0 && (vm.appointment.patient.firstName.trim() !== vm.initialFirstName.trim() || vm.appointment.patient.lastName.trim() !== vm.initialLastName.trim()))
            {
                if (vm.appointment.patient.updateNewStatus !== PatientConstant.New)
                {
                    // if userModifyingPopup returns true we continue, otherwise we cancel so user can check 
                    ContactService.showUserIsBeingModifiedPopUp(vm.initialFirstName.trim(), vm.initialLastName.trim(), vm.appointment.patient.firstName.trim(), vm.appointment.patient.lastName.trim())
                        .result
                        .then(function (okToSaveAppointment)
                        {
                            if (okToSaveAppointment)
                            {
                                vm.save();
                            }
                        });
                }else{
                    vm.save();
                }
            }else{
                vm.save();
            }
        }
            
        vm.save = function () {
            if (vm.moreThanOneEmail()) {
                Alert.error('single_email_allowed');
                return;
            }
            
            // ask confirmation if videoconsulttype
            // object to save
            var app = new Appointment();
            angular.copy(vm.appointment, app);

            // set agenda id
            app.fK_Agenda = vm.agenda.id;    

            // prepare for save
            app.prepareForSave(new Date(DateService.data.date));

            // save or update
            if (app.id > 0) {
                // update

                // if appointment has no recurrences, update without recurrence options
                if (!app.recurrence || app.recurrence.once) {
                    updateAppointment(app, null);
                } // If
                else {
                    // if appointment had existing recurrences, ask user how to update them
                    if (app.recurrence.id > 0) {
                        AppointmentRecurrenceUpdateService.getUpdateMethod().then(function (recurrenceUpdate) {
                            updateAppointment(app, recurrenceUpdate);
                        });
                    }
                    else {
                        // otherwise set default method so that the new recurrences are created correctly
                        updateAppointment(app, RecurrenceUpdateMethod.Future.value);
                    }
                } // else if
            } // if
            else {
                // save
                AppointmentService.save(app).then(function (result) {
                    // clean
                    AppointmentDetailService.data.agendaItem = null;
                    //// show protocol
                    protocols();

                    // show detail of appointment if ringfoon
                    if ($rootScope.isRingfoon) {

                        var values = {
                            date: RfGlobalLongDateFilterFilter(result.appointmentDate),
                            time: result.timeCaption,
                            doctor: vm.agenda.owner.caption,
                            patient: result.patient.caption,
                            type: result.appointmentType.caption

                        };
                        $translate('goodbye_message_after_appointment', values).then(function (result) {
                            AppointmentDetailService.afterNewAppointment(result);
                        });
                    } //if

                    // clear external loaded user in localstorage after creating appointment
                    UserService.clearExternalPatient();

                    // back to agenda-view
                    showAgenda(result.appointmentDate);
                });
            } // else

        }; // save    

        vm.onAppointmentTypeChanged = function(appointmentType) {
            if (!vm.appointment) {
                return;
            }

            // check if this is an existing appointment & the changed appointmenttype is equal to the current 
            // appointmenttype for this appointment => don't overwrite the appointment duration
            if (vm.appointment.id > 0) {
                if (vm.appointment.appointmentType.id !== appointmentType.id) {
                    vm.appointment.duration = appointmentType.duration;                    
                }

                validateAppointment(vm.appointment.duration);
            } else {
                vm.appointment.duration = appointmentType.duration;
                validateAppointment(appointmentType.duration);
            }

            vm.defaultLocationName = appointmentType.internalLocationName || vm.agenda.owner.internalLocationName;
            vm.isDefaultLocationFromAppointmentType = !!appointmentType.internalLocationId;
            setCorrectSettingsForPatient(appointmentType);
        };

        vm.onDurationChanged = function(duration) {
            if (!vm.appointment) {
                return;
            }
            
            validateAppointment(duration);
            vm.appointment.duration = duration;
        }

        vm.selectLocation = function(location) {            
            vm.appointment.internalLocation = !location.id ? null : location;            
        };

        vm.changeUnKnownPatientStatus = function(patientUnknown) {
            
            vm.appointment.unknownPatient = patientUnknown;
            loadUnknownPatientText();
            
        };
                
        function loadUnknownPatientText()
        {
            if (vm.appointment.unknownPatient)
            {
                vm.newOrUnknownText = $translate.instant('new');
            }else{
                vm.newOrUnknownText = $translate.instant('patientstate_Known');
            }
        }

        // call service method to update appointment
        function updateAppointment(appointment, recurrenceUpdateMethod) {
            AppointmentService.update(appointment.id, appointment, true, recurrenceUpdateMethod).then(function (result) {
                showAgenda(appointment.appointmentDate);
            });
        } // updateAppointment

        function setCorrectSettingsForPatient(appointmentType)
        {
            if (!vm.appointment.patient.contactInfos)
            {
                vm.appointment.patient.contactInfos = [];
            }
            // check if videoconsulttype
            if (appointmentType.isVideoConsultType)
            {
                vm.appointment.reminderMessagesEnabled = true;
                vm.appointment.sendConfirmationMailToClient = true;
                vm.appointment.sendConfirmationMailToPatient = true;
            }
            if (appointmentType.isVideoConsultType || appointmentType.amountToBePaidUpfront > 0)
            {
                // email needs to be required
                let emailContactInfos = vm.appointment.patient.contactInfos.filter(x=> x.fK_UserContactInfoType === 3 || (x.userContactInfoType && x.userContactInfoType.id === 3));
                if (emailContactInfos.length > 0)
                {
                    emailContactInfos[0].required = true;
                }else{
                    // create emailContactInfo
                    let contactInfoType = new UserContactinfoType();
                    contactInfoType.id = 3;
                    contactInfoType.type = 3;
                    contactInfoType.caption= "Email";
                    let info = new ContactInfo();
                    info.required = true;
                    info.init(contactInfoType);
                    $scope.$emit(AgendaBroadcast.AddContactInfo, info);
                }
            }
            else{
                // reset emailcontactinfos to not required
                vm.appointment.patient.contactInfos.forEach(element => element.required = false);
            }
            // split contact-infos
            vm.appointment.setNeededContactInfoTypes(vm.agenda.contactInfoTypesInAppointment);
            vm.appointment.setNeededAdditionalInfoTypes(vm.additionalinfotypes);

            vm.userBlocked = vm.appointment.patient.isBlockedInMyOrganizer;
            vm.initialFirstName = vm.appointment.patient.firstName;
            vm.initialLastName = vm.appointment.patient.lastName;

            // default language of the patient is the language they already have, else the agenda language
            // when creating a new appointment, the patient gets their language trough languageId, when editing an appointment it has their language set trough fK_Language
            // this if-statement makes sure fK_Language is never undefined, fK_Language gets used in the backend
            if (vm.appointment.patient.languageId !== undefined)
            {
                vm.appointment.patient.fK_Language = vm.appointment.patient.languageId;
            }
        }

        // show Protocols
        function protocols() {
            // only for ringfoon
            if (!$rootScope.isRingfoon) { return; }

            // Show-On-Appointment-Save
            ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnAppointmentSave);

            // Show-New-Patient-Selection (if agenda does not allow new patients)
            if (!SharedAgendaService.data.currentAgenda.acceptNewPatients && vm.appointment.patient.updateNewStatus === PatientConstant.New) {
                ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnNewPatientNotAllowed);
            } // if

            // Show-New-Patient-Selection
            ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnNewPatientSelection);

        } // protocols

        function showAgenda(appointmentDate) {        
            var stateName = PreviousState ? PreviousState.name : 'Home.Agenda_Day';
            $state.go(stateName);            
        }

        // listen on changes
        function listen() {

            // listen on agenda-label changes
            labelWatcher = $scope.$watch(function () {
                return vm.appointment.agendaLabel;
            }, function (newLabel, oldLabel) {
                $timeout(function() {
                    // set confirmation flags and reminder settings if: 
                    // - new appointment
                    // - existing appointment & label changes
                    if (!vm.appointment.id ||
                        (newLabel.agendaLabelId &&
                            vm.appointment.fK_AgendaLabel &&
                            vm.appointment.fK_AgendaLabel !== newLabel.agendaLabelId)) {
                        updateConfirmationFlags();
                    }

                    // always set the correct remindertoggles and info
                    updateReminderToggle();
                    setCorrectSettingsForPatient(vm.appointment.appointmentType);
                }, 0);
            });

            // listen on selected user
            userWatcher = $scope.$watch(function () {
                return vm.appointment.patient;
            }, function (newVal, oldVal) {
                // only do something when value is changed
                if(oldVal && oldVal.id !== newVal.id){
                    setCorrectSettingsForPatient(vm.appointment.appointmentType);
                    if (newVal.id === 0) {
                        vm.appointment.patient.updateNewStatus = PatientConstant.New;
                        vm.changeUnKnownPatientStatus(true);
                    }else{
                        vm.appointment.patient.updateNewStatus = PatientConstant.Update;
                        vm.changeUnKnownPatientStatus(false);
                    }
                }
            });
            

            // listen on event
            addListener = $scope.$on(AgendaBroadcast.AddAdditionalInfo, function (ev, item) {
                vm.appointment.additionalAppointmentInfos.push(item);
            });

            // listen on event
            ciListener = $scope.$on(AgendaBroadcast.AddContactInfo, function (ev, item) {
                if (!vm.appointment.patient.contactInfos){
                    vm.appointment.patient.contactInfos = [];
                }

                // check if its an email and if there already is one
                if (item.fK_UserContactInfoType === 3) {
                    if (emailsInContactInfos() > 0) {
                        Alert.error('single_email_allowed');
                        return;
                    }
                }
                
                vm.appointment.patient.contactInfos.push(item);                
            });

        } // listen
        
        function emailsInContactInfos() {
            let count = 0;
            for (let i = 0; i < vm.appointment.patient.contactInfos.length; i++) {
                if (vm.appointment.patient.contactInfos[i].userContactInfoType.type === 3) {
                    count++;
                }
            }
            return count;
        }
        
        vm.moreThanOneEmail = () => {
            return emailsInContactInfos() > 1;
        };
        
        // update reminders toggle in appointment
        function updateReminderToggle(){
            // if label is selected
            if (vm.appointment.agendaLabel) {
                vm.appointment.hoursBeforeEmailReminderIsSent = vm.appointment.agendaLabel.hoursBeforeEmailReminderIsSent;
                vm.appointment.hoursBeforeSMSReminderIsSent = vm.appointment.agendaLabel.hoursBeforeSMSReminderIsSent;
                
                if (vm.appointment.id === 0){
                vm.appointment.reminderMessagesEnabled = vm.appointment.hoursBeforeEmailReminderIsSent > 0 || vm.appointment.hoursBeforeSMSReminderIsSent > 0;
                }

                let appointmentDate = new Date(DateService.data.date);
                appointmentDate.setHours(vm.appointment.agendaLabel.hour);
                appointmentDate.setMinutes(vm.appointment.agendaLabel.minute);
                appointmentDate.setSeconds(0);
                appointmentDate.setMilliseconds(0);
                let smsRemindersSentUntil = new Date();
                let emailRemindersSentUntil = new Date();
                smsRemindersSentUntil.setTime(appointmentDate.getTime() - (vm.appointment.hoursBeforeSMSReminderIsSent*60*60*1000));
                emailRemindersSentUntil.setTime(appointmentDate.getTime() - (vm.appointment.hoursBeforeEmailReminderIsSent*60*60*1000));
                vm.appointment.smsReminderTimeExceeded = smsRemindersSentUntil < new Date();
                vm.appointment.emailReminderTimeExceeded = emailRemindersSentUntil < new Date();
                vm.appointment.reminderNotEditable = ( vm.appointment.agendaLabel.hoursBeforeEmailReminderIsSent === 0 &&
                        vm.appointment.agendaLabel.hoursBeforeSMSReminderIsSent === 0 ) ||
                    vm.appointment.smsReminderTimeExceeded ||
                    vm.appointment.emailReminderTimeExceeded;
                
                $("#reminderToggle").bootstrapSwitch('state', vm.appointment.reminderMessagesEnabled);
            }
        }

        // update confirmation flags in appointment
        function updateConfirmationFlags() {

            vm.disableConfirmationOptions = !vm.agenda.setAppointmentConfirmationFlags;

            // if label is selected
            if (vm.appointment.agendaLabel) {
                // send confirmation text message to patient
                vm.appointment.sendConfirmationSMSToPatient = vm.appointment.agendaLabel.sendConfirmationSMSToPatient;
                // send confirmation text message to client ? 
                // --> If Main user is booking the appointment: don't send SMS to himself by default
                vm.appointment.sendConfirmationSMSToClient = !$rootScope.isMainuser && vm.appointment.agendaLabel.sendConfirmationSMSToClient;
                // send confirmation mail to patient ?
                vm.appointment.sendConfirmationMailToPatient = vm.appointment.agendaLabel.sendConfirmationMailToPatient;
                // send confirmation mail to client ? 
                // --> If Main user is booking the appointment: don't send Email to himself by default
                vm.appointment.sendConfirmationMailToClient = !$rootScope.isMainuser && vm.appointment.agendaLabel.sendConfirmationMailToClient;

                // can we override ? If label is TRUE Or It Is The Day-Itself
                if (!vm.dayItself) {
                    vm.appointment.sendConfirmationSMSToClient = false;                
                }                

            } //if
        } // updateConfirmationFlags

        function loadInternalLocations() {
            vm.groupPracticeId = SharedAgendaService.currentUser().groupPracticeId;
            GroupPracticeService.getInternalLocations(vm.groupPracticeId)
                .then(function(locations) {
                    locations.unshift({
                        id: null,
                        name: ' - '
                    });

                    vm.locations = locations;
                });
        }

        // activation work
        function activate() {
            // block changing agenda
            SharedAgendaService.block();

            activationWork();                    
            loadInternalLocations();
        } // activate

        function validateAppointment(duration) {

            if (!vm.appointment ||
                !vm.appointment.agendaLabel ||
                !vm.appointment.appointmentType ||
                !duration
                || vm.appointment.unknownPatient === undefined) {
                    return;
            }
            
            const appointmentDate = new Date(DateService.data.date);
            appointmentDate.setHours(vm.appointment.agendaLabel.hour);
            appointmentDate.setMinutes(vm.appointment.agendaLabel.minute);
            appointmentDate.setSeconds(0);
            appointmentDate.setMilliseconds(0);
            
            AppointmentService.validateAppointment(vm.agenda.id, appointmentDate, duration)
                    .then(function(validationResult) {                        
                        vm.notEnoughTimeForAppointmentType = validationResult.notEnoughTimeForAppointmentType;
                    });
        }
        
        // activation work
        function activationWork() {

            // remove date from service
            AppointmentDetailService.data.time.hour = null;
            AppointmentDetailService.data.time.minute = null;
            AppointmentDetailService.data.doTimeChecks = true; // force now time-checks           

            // appointment from service
            vm.appointment = AppointmentDetailService.data.appointment;
            
            if (vm.appointment.id > 0 )
            {
                vm.disableConfirmationOptions = !AppointmentDetailService.data.agenda.setAppointmentConfirmationFlags;
                // if editing appointment and less than 9 minutes (in api it is 10min) -> enable otherwise, disable while editing as
                // confirmation messages have already been sent
                let checkboxesMaxTime = new Date(vm.appointment.createDate);
                checkboxesMaxTime.setMinutes(checkboxesMaxTime.getMinutes() + 9);
                if (new Date() > checkboxesMaxTime && AppointmentDetailService.data.agenda.setAppointmentConfirmationFlags)
                {
                    vm.disableConfirmationOptions = true;
                }
            }
            
            // if recurrence options have been set, enable the options in the view
            if (vm.appointment.recurrence.id > 0) {
                vm.appointment.recurrence.once = false;
            } // if          
            
            // preselect patient if incoming data from external system
            if (vm.appointment.id === 0 && SharedAgendaService.data.currentAgenda.allowPhoneNumberRecognition) {
                UserService.preSelectExternalPatient(vm.appointment, AppointmentDetailService.data.agenda.owner.id, AppointmentDetailService.data.agenda.id);
            }
            

            // set needed values for directives
                    
            // if double-booking or editing an appointment -> Add label (AgendaItemDto) to the list of labels
            if (AppointmentDetailService.data.agendaItem !== null) {
                // Manually Double Booked                
                vm.appointment.doubleBooking = true;                

                // we are editing an appointment -> push the agendaItem as label to the list of labels
                AppointmentDetailService.data.labels.push(AppointmentDetailService.data.agendaItem);
            }
            vm.labels = AppointmentDetailService.data.labels;

            vm.types = AppointmentDetailService.data.types;
            vm.additionalinfotypes = additionalinfotypes;            
            vm.agendaOwnerCaption = AppointmentDetailService.data.agenda.owner.caption;
            
            // current agenda and date
            vm.agenda = AppointmentDetailService.data.agenda;
            vm.defaultLocationName = vm.agenda.owner.internalLocationName;

            vm.date = DateService.getDateCaption();
            // list of duration intervals (shown if no duration at appointment-type)
            vm.durationIntervals = HelperService.generateDurationIntervals();
            // default interval
            if (vm.appointment.id <= 0) {
                // default interval/duration
                vm.appointment.duration = vm.agenda.interval;
                // mandatory text for appointment
                vm.appointment.content = vm.agenda.mandatoryTextInAppointment || '';
                // by default "unknown patient" should be shown, unless its known in an external system
                vm.appointment.unknownPatient = vm.appointment.unknownPatient === undefined || vm.appointment.unknownPatient;
            } // if

            // set status (update/new)
            loadUnknownPatientText();

            // set week-of-month selection list
            vm.weekOfMonthValues.push(RecurrenceWeekOfMonth.First);
            vm.weekOfMonthValues.push(RecurrenceWeekOfMonth.Second);
            vm.weekOfMonthValues.push(RecurrenceWeekOfMonth.Third);
            vm.weekOfMonthValues.push(RecurrenceWeekOfMonth.Fourth);
            vm.weekOfMonthValues.push(RecurrenceWeekOfMonth.Last);

            // Day-Itself -> appointment made today ?
            vm.dayItself = DateService.isToday();

            // listen
            listen();
            
            // clean
            additionalinfotypes = null;

            // on destroy
            $scope.$on("$destroy", function () {
                labelWatcher();
                labelWatcher = null;
                userWatcher();
                userWatcher = null;
                addListener();
                addListener = null;
                ciListener();
                ciListener = null;
            });
        } // activationWork


        activate();
    }

})();